import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";

const TRANSLATION_PREFIX =
  "settings.contracts.onboardingStudio.workflowDetail.removeFromStageModal";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isConfirmed: boolean;
  setIsConfirmed: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
}

const OnboardingRemoveFromStageModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  isConfirmed,
  setIsConfirmed,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t(`${TRANSLATION_PREFIX}.title`)}
      confirmationText={
        <div className="flex flex-col gap-4">
          <Text>{t(`${TRANSLATION_PREFIX}.text1`)}</Text>
          <Text>{t(`${TRANSLATION_PREFIX}.text2`)}</Text>
        </div>
      }
      handleSubmit={onConfirm}
      submitButtonText={t("remove")}
      checkboxLabel={t(`${TRANSLATION_PREFIX}.checkboxLabel`)}
      isCheckboxRequired={true}
      onCheckboxChange={setIsConfirmed}
      isCheckboxChecked={isConfirmed}
    />
  );
};

export default OnboardingRemoveFromStageModal;
